/* eslint-disable no-undef */
import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import MainLayout from '../../containers/MainLayout/MainLayout';
import MainSearch from '../../containers/MainSearch/MainSearch';
import ProviderPageRightPart from '../../containers/Provider/ProviderPageRightPart/ProviderPageRightPart';
import ProviderPageLeftPart from '../../containers/Provider/ProviderPageLeftPart/ProviderPageLeftPart';


const ProviderPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const { footerData } = props;

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <ProviderPageLeftPart />
                <ProviderPageRightPart />
              </div>
              <MainSearch />
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

ProviderPage.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

ProviderPage.defaultProps = {
  footerData: {},
};
export default ProviderPage;
